import buttonStyles from "@/styles/Buttons.module.scss"
import formStyles from "@/styles/Forms.module.scss"
import { setAlert } from "@/store/slices/alertSlice"
import { Form, Formik } from "formik"
import { useDispatch } from "react-redux"
import * as Yup from "yup"
import InputField from "../fields/InputField"
import PasswordInput from "./formik/PasswordInput"
import classNames from "classnames"
import { updateUser } from "@/api/nextme/users"
import {
  emailValidator,
  passwordConfirmationValidator,
  passwordValidator,
} from "@/utils/formik-validators"
import { AccountStatusEnum } from "@/consts/AccountStatusEnum"
import { User } from "@/api/interface/user"

interface Props {
  handleSuccess: Function
  submitButtonText: string
  userEmail?: string
  userId?: string
}

export default function PasswordChangeForm({
  handleSuccess,
  submitButtonText,
  userEmail,
  userId,
}: Props) {
  const dispatch = useDispatch()

  const initialValues = {
    email: userEmail || "",
    currentPassword: "",
    password: "",
    passwordConfirmation: "",
  }

  const validationSchema = Yup.object({
    email: userEmail && emailValidator().required("Required"),
    currentPassword: passwordValidator().required("Required"),
    password: passwordValidator().required("Required"),
    passwordConfirmation: passwordConfirmationValidator().required("Required"),
  })

  const onSubmit = async (values) => {
    const { email, ...vals } = values

    const submission: Partial<User> = {
      ...vals,
      id: userId,
      passwordConfirmation: values.password,
      status: AccountStatusEnum.enabled,
    }

    await updateUser(submission)

    dispatch(
      setAlert({
        title: "Success",
        isOpen: true,
        message: "Your password has been changed.",
      })
    )

    handleSuccess()
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form className={formStyles.form}>
          {userEmail && (
            <>
              <InputField
                autoComplete="off"
                id="pw-change-form-email"
                label="Email"
                name="email"
                disabled
                required
              />
              <PasswordInput
                autoComplete="current-password"
                name="currentPassword"
                label="Current Password"
                required
                hideErrorEmpty
              />
              <br />
            </>
          )}
          <PasswordInput
            autoComplete="new-password"
            name="password"
            label="New Password"
            required
            hideErrorEmpty
          />
          <br />
          <PasswordInput
            autoComplete="new-password"
            name="passwordConfirmation"
            label="Confirm Password"
            required
            hideErrorEmpty
          />
          <br />
          <button
            className={classNames(buttonStyles.enabledGreenBtn, "btn w-100")}
            onClick={(e) => isSubmitting && e.preventDefault()}
            type="submit"
            disabled={isSubmitting}
          >
            {submitButtonText}
          </button>
        </Form>
      )}
    </Formik>
  )
}
